import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Portal } from 'react-portal'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ButtonClose from '../../features/components/Buttons/ButtonClose'
import DrawerHeadline from './DrawerHeadline'

import { isNewStylesThemeEnabledSelector } from '../../modules/selectors/app'

import useStyles from './style'
import * as vanilla from './index.css'

function Drawer({
  width,
  isOpen,
  onClose,
  className,
  classNameContent,
  classNameBody,
  children,
  portalProps,
  title,
  description
}) {
  const isNewStylesThemeEnabled = useSelector(isNewStylesThemeEnabledSelector)

  const legacyClasses = useStyles(isOpen)

  const vanillaClasses = {
    ...vanilla,
    backdrop: vanilla.backdrop[isOpen]
  }
  const activeClasses = isNewStylesThemeEnabled ? vanillaClasses : legacyClasses

  const bodyContainer = useRef(null)

  useEffect(() => {
    if (isOpen) {
      document.querySelector('body').style.overflow = 'hidden'
      bodyContainer.current.scrollTo(0, 0)
    } else {
      document.querySelector('body').style.overflow = ''
    }
  }, [isOpen])

  const contentSpacing = isOpen ? 0 : '100%'

  return (
    <Portal node={document && document.body} {...portalProps}>
      <div className={className}>
        <div
          onClick={onClose}
          className={activeClasses.backdrop}
          style={{ transform: `translateX(${contentSpacing})` }}
        />
        <div
          className={classnames(activeClasses.content, classNameContent)}
          style={{ width, transform: `translateX(${contentSpacing})` }}
        >
          {/*data-content is used as an identifier to have ability scroll drawer content*/}
          {/*for example that is done on step change form*/}
          <div ref={bodyContainer} className={activeClasses.bodyContainer} data-content={'bodyContainer'}>
            <ButtonClose className={activeClasses.closeBtn} onClick={onClose} />
            <div className={classnames(activeClasses.body, classNameBody)}>
              <DrawerHeadline title={title} description={description} />
              {isOpen && children}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}

Drawer.propTypes = {
  width: PropTypes.string,
  className: PropTypes.string,
  classNameContent: PropTypes.string,
  classNameBody: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
}

export default Drawer
